import React, { PropTypes } from 'react';
import StreamVoD from './../StreamVoD'

import { Tabs, Tab } from 'material-ui/Tabs';

class StreamVODRoot extends React.Component {
  static propTypes = {
    switchTab: PropTypes.func.isRequired,
    children: PropTypes.node
  };

  static contextTypes = {
    muiTheme: React.PropTypes.object
  };

  defaultProps = {
    displayStatus: false
  };
  componentWillMount(){
    this.props.categories_actions.fetch();
  }

  initialSelectedTab(list) {
    return Math.max(0, list.indexOf(this.props.location.pathname.split('/')[4]))
  }

  render() {

    const { categories_state, params } = this.props;
    const { filter, list, items, loading } = categories_state
    const { category_id } = params
    const categoryId = category_id || list[0]
    
    const { palette: { labelColor } } = this.context.muiTheme;
    
    return (loading || !filter) ? null : list.length ? (
      <div>
         <Tabs initialSelectedIndex={this.initialSelectedTab(list)} style={{
           zIndex: 1,
           position: 'sticky',
           top: '112px',
           boxShadow: 'rgb(0 0 0 / 16%) 0px 3px 10px, rgb(0 0 0 / 23%) 0px 3px 10px'
         }}>
          { list.map(category_id => (
                <Tab
                    key={ category_id }
                    style={{ color: labelColor }}
                    label={ items[category_id].name }
                    onClick={() => this.props.switchTab(category_id)}
                />
              )
            )
          }
        </Tabs>
        <StreamVoD key={categoryId} categoryId={ categoryId }/>
       </div>
     ) : <StreamVoD />
  }
}

export default StreamVODRoot;



// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/StreamVoDRoot/StreamVoDRoot.jsx